export enum ActiveCampaignTriggerEnum {
  contact_created = 'contact_created',
  tag_added_to_contact = 'tag_added_to_contact',
  tag_removed_from_contact = 'tag_removed_from_contact',
}

export const ActiveCampaignTriggerTitle: Record<ActiveCampaignTriggerEnum, string> = {
  [ActiveCampaignTriggerEnum.contact_created]:
    'dashboard.user_settings.integrations_page.active_campaign.contact_created_title',
  [ActiveCampaignTriggerEnum.tag_added_to_contact]:
    'dashboard.user_settings.integrations_page.active_campaign.tag_added_title',
  [ActiveCampaignTriggerEnum.tag_removed_from_contact]:
    'dashboard.user_settings.integrations_page.active_campaign.contact_removed_title',
}
